import { EntityState } from '@reduxjs/toolkit';
import { ServerFeature } from '../../../../models/app';

/* Allowed/Available Device types. Any new device type has to be added here for support */
export const allowedDeviceType = {
  STATION_CODENAME: 'GOLDLEAF',
  STATION2_CODENAME: 'GOLDENOAK',
  MOBILE_CODENAME: 'LEAFCUTTER',
  MINI_CODENAME: 'MAPLECUTTER',
  MINI2_CODENAME: 'KNOTTYPINE',
  FLEX_CODENAME: 'BAYLEAF',
  MINI_SI_CODENAME: 'HOLLOWPINE',
  GMC_CODENAME: 'GMC',
  FLEX2_CODENAME: 'BAMBOOLEAF',
  CLOVER_GO3_CODENAME: 'TEALEAF',
  STATION3_CODENAME: 'GOLDENACORN',
  MINI_3RD_GENERATION_CODENAME: 'MAPLETHREE',
  FLEX_3RD_GENERATION_CODENAME: 'FICUSTREE',
  STATION_DUO_2ND_GENERATION_CODENAME: 'HOLLOWMAPLE',
  STATION4_CODENAME: 'SILVERACORN',
  KEYLIME_KDS_CODENAME: 'KEYLIME',
  FLEX_4_CODENAME: 'FIGTREE',
  FLEX_4_POCKET_CODENAME: 'FIGPIE',
  KEYLIMEPIE_KDS_CODENAME: 'KEYLIMEPIE',
  KIOSK_CODENAME: 'SUGARMAPLE',
  COMPACT_CODENAME: 'PINETREE',
  COMPANION_CODENAME: 'PINETREESEMI'
};

/* Available Device Feature Flags */
export const deviceFeatureFlags = {
  flexReleasedFeature: 'BAYLEAF_RELEASED',
  station2Released: 'GOLDENOAK_RELEASED',
  stationSoloReleased: 'GOLDENACORN_RELEASED',
  mini2Released: 'KNOTTYPINE_RELEASED',
  stationProReleased: 'GMC_RELEASED',
  flex2Released: 'BAMBOOLEAF_RELEASED',
  mini3Released: 'MAPLETHREE_RELEASED',
  flex3Released: 'FICUSTREE_RELEASED',
  stationSoloInternationalReleased: 'SILVERACORN_RELEASED',
  stationDuo2Released: 'HOLLOWMAPLE_RELEASED',
  kdsReleased: 'KEYLIME_RELEASED',
  flex4Released: 'FIGTREE_RELEASED',
  flex4PReleased: 'FIGPIE_RELEASED',
  kdsXLReleased: 'KEYLIMEPIE_RELEASED',
  kioskReleased: 'SUGARMAPLE_RELEASED',
  compactReleased: 'PINETREE_RELEASED',
  companionReleased: 'PINETREESEMI_RELEASED'
};

export const checkAllowedDevicetypes = (response: string[]) => {
  let allowedDeviceTypeCollection: string[] = [];
  let deviceTypeCollectionToDisplay: string[] = [];
  Object.values(allowedDeviceType).forEach(value => allowedDeviceTypeCollection.push(value));
  deviceTypeCollectionToDisplay = response.filter(el => {
    return allowedDeviceTypeCollection.includes(el);
  });
  return deviceTypeCollectionToDisplay;
};

export const displaySupportedDevices = (
  deviceServerFeatures: EntityState<ServerFeature>,
  deviceTypes: string[],
): string[] => {
  /* 1.All the required device fetured flag and devicetype are checked below.
    2. device feature flag should be enabled to view its corresponsing device type.
 */
  let result: string[] = [],
    map: Record<string, boolean> = {};

  deviceTypes.forEach(deviceType => {
    for (let i = 0; i < deviceServerFeatures?.ids.length; i++) {
      let deviceTypeStr = '';
      let id = deviceServerFeatures?.ids[i];
      let entity = deviceServerFeatures?.entities[id];
      if (!entity) {
        continue;
      }
      let deviceServerFeatureName = entity.name;
      let isDeviceServerFeature = entity.enabled;

      if (
        deviceServerFeatureName === deviceFeatureFlags.flexReleasedFeature &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.FLEX_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_flex_short';
      } else if (
        deviceServerFeatureName === deviceFeatureFlags.station2Released &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.STATION2_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_station2_short';
      } else if (
          (
              deviceServerFeatureName === deviceFeatureFlags.stationSoloReleased &&
              isDeviceServerFeature &&
              deviceType === allowedDeviceType.STATION3_CODENAME
          ) ||
          (
              deviceServerFeatureName === deviceFeatureFlags.stationSoloInternationalReleased &&
              isDeviceServerFeature &&
              deviceType === allowedDeviceType.STATION4_CODENAME
          )
      ) {
        deviceTypeStr = 'device_type.clover_station_solo_short';
      } else if (
        deviceServerFeatureName === deviceFeatureFlags.mini2Released &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.MINI2_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_mini2_short';
      } else if (
        deviceServerFeatureName === deviceFeatureFlags.stationProReleased &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.GMC_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_gmc_short';
      } else if (
        deviceServerFeatureName === deviceFeatureFlags.flex2Released &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.FLEX2_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_flex2_short';
      } else if (
          deviceServerFeatureName === deviceFeatureFlags.flex3Released &&
          isDeviceServerFeature &&
          deviceType === allowedDeviceType.FLEX_3RD_GENERATION_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_flex3_short';
      } else if (
          deviceServerFeatureName === deviceFeatureFlags.flex4Released &&
          isDeviceServerFeature &&
          deviceType === allowedDeviceType.FLEX_4_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_flex4_short';
      } else if (
		deviceServerFeatureName === deviceFeatureFlags.flex4PReleased &&
		isDeviceServerFeature &&
		deviceType === allowedDeviceType.FLEX_4_POCKET_CODENAME
	) {
	  deviceTypeStr = 'device_type.clover_flex4P_short';
	} else if (
        deviceServerFeatureName === deviceFeatureFlags.mini3Released &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.MINI_3RD_GENERATION_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_mini3_short';
      } else if (
        deviceServerFeatureName === deviceFeatureFlags.stationDuo2Released &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.STATION_DUO_2ND_GENERATION_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_stationDuo2_short';
      } else if (
        deviceServerFeatureName === deviceFeatureFlags.kdsReleased &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.KEYLIME_KDS_CODENAME
	  ) {
        deviceTypeStr = 'device_type.clover_kds_short';
	  } else if (
        deviceServerFeatureName === deviceFeatureFlags.kdsXLReleased &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.KEYLIMEPIE_KDS_CODENAME
	  ) {
        deviceTypeStr = 'device_type.clover_kds_xl_short';
      } else if(
        deviceServerFeatureName === deviceFeatureFlags.kioskReleased &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.KIOSK_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_kiosk';
	  } else if(
        deviceServerFeatureName === deviceFeatureFlags.compactReleased &&
        isDeviceServerFeature &&
        deviceType === allowedDeviceType.COMPACT_CODENAME
      ) {
        deviceTypeStr = 'device_type.clover_compact';
	  } else if(
      deviceServerFeatureName === deviceFeatureFlags.companionReleased &&
      isDeviceServerFeature &&
      deviceType === allowedDeviceType.COMPANION_CODENAME
    ) {
      deviceTypeStr = 'device_type.clover_companion';
    } else if (deviceType === allowedDeviceType.STATION_CODENAME) {
        deviceTypeStr = 'device_type.clover_station_short';
      } else if (deviceType === allowedDeviceType.MOBILE_CODENAME) {
        deviceTypeStr = 'device_type.clover_mobile_short';
      } else if (deviceType === allowedDeviceType.MINI_CODENAME) {
        deviceTypeStr = 'device_type.clover_mini_short';
      }
      if (deviceTypeStr && !map[deviceTypeStr]) {
        map[deviceTypeStr] = true;
        result.push(deviceTypeStr);
      }
    }
  });
  return result;
};
